import React, { memo, useState } from 'react'
import { ToggleOverlayBtn } from './ToggleOverlayBtn'

export const OverlayPanelWrapper = memo(props => {
  const { children, renderOverlayPanel } = props || {}
  const [open, setOpen] = useState(false)

  return (
    <>
      <ToggleOverlayBtn onClick={() => setOpen(true)}>
        {children}
      </ToggleOverlayBtn>
      {renderOverlayPanel(open, setOpen)}
    </>
  )
})
